import { sortBy } from "lodash";

export default {
  name: "EventInfos",
  data: () => ({
    regionalities: [
      { title: "regional", value: "communal" },
      { title: "lokal", value: "local" },
      { title: "überregional", value: "regional" },
      { title: "intern", value: "internal" }
    ],
    mainPeacock: "#00636C"
  }),
  props: [
    "editedEvent",
    "step",
    "position",
    "featureGroups",
    "ownFeatures",
    "ownFeatureGroups",
    "isOwnedBySubPrincipal"
  ],
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
    isAdmin() {
      return this.currentUser?.scopes?.includes("role:admin");
    },
    isEventAdmin() {
      return (
        this.isAdmin || this.currentUser?.scopes?.includes("role:events_admin")
      );
    },
    featureGroupsWithFeatures() {
      const featureGroups = this.featureGroups.filter(
        fg => !!fg.features.length
      );

      featureGroups.forEach(featureGroup => {
        featureGroup.features = sortBy(featureGroup.features, feature =>
          feature.title.toLowerCase()
        );
      });
      return featureGroups;
    }
  },
  methods: {
    addFeatureToEvent(featureId) {
      if (this.editedEvent?.features?.includes(featureId))
        this.editedEvent?.features?.remove(featureId);
      else this.editedEvent?.features?.push(featureId);
    },
    isAppFeature(feature) {
      return !!feature.appdinx_channel_id;
    },
    isOwnFeatureGroup(featureGroup) {
      return this.ownFeatureGroups.some(
        _featureGroup => _featureGroup._id === featureGroup
      );
    },
    isFeatureDisabled(feature) {
      if (!this.isFeatureEditable(feature)) {
        return true;
      }
      if (!this.isOwnedBySubPrincipal) {
        return false;
      }
      return !this.isOwnFeature(feature._id);
    },
    isOwnFeature(featureId) {
      return this.ownFeatures.includes(featureId);
    },
    isFeatureEditable(feature) {
      if (!feature.editable_by || feature.editable_by === "all") {
        return true;
      }
      if (feature.editable_by === "events_admin") {
        return this.isEventAdmin;
      }
      if (feature.editable_by === "admin") {
        return this.isAdmin;
      }
      throw new Error(
        `${feature.title}: invalid value for feature.editable_by: ${feature.editable_by}`
      );
    }
  }
};
